import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import DocumentTitle from 'react-document-title' 
import { connect } from 'react-redux'
import { login,googleLogin } from '../../actions/session'
import GoogleLogin from 'react-google-login'
import LoginForm from '../../components/forms/LoginForm'
import Icon from '../../components/misc/Icons'

const responseGoogle = (response) => {} 


class SignUpWithGoogleBtn extends React.Component{


	render(){  
    

   	 return(

    	<GoogleLogin
				clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
				onSuccess={this.props.googleLogin}
				onFailure={responseGoogle}
				className='signin-continueWithGoogleBtn signin-continueWithGoogleBtn--default'			
			>
	    
				<div className='signin-continueWithGoogleBtn-centerContent'>
					<div className='signin-continueWithGoogleBtn-centerContent-icon'>
						<Icon name='googleLogoSignInColor' />
						<Icon name='googleLogoSignInGray' />
					</div>
					<div className='signin-continueWithGoogleBtn-centerContent-label'>
						Continue with Google
					</div>
				</div>				

			</GoogleLogin>
 					
      	)
  	}
}
 


class Login extends Component {

	 constructor(props){
		super(props)
		this.goToSignup=this.goToSignup.bind(this)
		this.googleLogin=this.googleLogin.bind(this)
		this.handleLogin=this.handleLogin.bind(this)
		this.goToForgotPassword=this.goToForgotPassword.bind(this)
		this.state={
			loginError: null, 
			submitLoading:false
		}

	}
	


	googleLogin(googleUser){

		this.setState({submitLoading:true})
		const requestData={
			idToken:googleUser.tokenId
		}
		this.props.googleLogin(requestData).then((response) => {
			const authInstance=window.gapi.auth2.getAuthInstance()
			authInstance.disconnect()
		})
	}


	handleLogin(data){
		this.setState({submitLoading:true})
		const nowDate=new Date()
		this.setState({loginError:null})
		this.props.login(data).then((response) => {
		})
			.catch(error => {
				this.setState({submitLoading:false})

				this.setState({loginFormSubmittedAt:nowDate})
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(error.response && error.response.status===401){
					errorMessage='Please check that your email address and password are correct.'
				}else if(error.response && error.response.status===422){
					errorMessage=`We couldn’t find an account with the email ${data.email}`
				}
				this.setState({loginError:errorMessage})
			})
	}


	goToSignup(){
		this.props.history.push('signup')
	}

	goToForgotPassword(){
		this.props.history.push('forgot-password')
	}

	render() {
		return (
			<DocumentTitle title='Sign in - Plickers'>
				<div className='signin marketing notranslate'>
				
					<div className='signin-centerBlock'> 

						<div className='signin-centerBlock--top' />						
						<div className='signin-centerBlock--middle'>
							
							<div className='signin-centerBlock-logo'>
								<Icon name='logo-full' />
							</div>
							
							<div className='signin-centerBlock-spacer' />
							

							<div className='signin-centerBlock-divider'>
								<div className='signin-centerBlock-divider-line' />
								<div className='signin-centerBlock-divider-label'>
									or sign in with email and password
								</div>
								<div className='signin-centerBlock-divider-line' />

							</div>
							
							<LoginForm 
								onSubmit={this.handleLogin} 
								loginError={this.state.loginError} 
								loginFormSubmittedAt={this.state.loginFormSubmittedAt}
								submitLoading={this.state.submitLoading}
							/>
							<SignUpWithGoogleBtn googleLogin={this.googleLogin}/>

							<div className='signin-centerBlock-forgotPasswordContainer'> 
								<div className='signin-centerBlock-forgotPassword' onClick={this.goToForgotPassword}> 
									Forgot Password?
								</div>
							</div>

						</div>


						

						<div className='signin-centerBlock--bottom'>						
							<div className='signin-centerBlock-goToCreateAccount' onClick={this.goToSignup}> 
								Don’t have an account? Sign up for free
							</div>	

												
						</div>
					
					
					</div>		
		
				</div>
			</DocumentTitle>
		)
	}
}


export default withRouter(connect(
	(state) => ({

	} ),
	{ login,
		googleLogin,
		 })(Login))
	